import React from 'react';

import {
  Table,
  TableCell,
  TableBody,
  TableRow,
  Typography,
  TableContainer,
  Link,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import MasterCampaignDetails from 'scenes/Influencers/MasterCampaigns/components/MasterCampaignDetails';

const MasterCampaigns = ({ data }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenMasterCampaign = ({ id }) => {
    openChildComponent(MasterCampaignDetails, {
      id,
    });
  };

  return data?.length ? (
    <TableContainer>
      <Table width={'100%'}>
        <TableBody>
          {data.map(({ id, name }, i) => (
            <TableRow key={i}>
              <TableCell>
                <Link onClick={() => handleOpenMasterCampaign({ id })}>
                  {name}
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {childComponent}
    </TableContainer>
  ) : (
    <Typography color={'textSecondary'}>No campaigns</Typography>
  );
};

export default MasterCampaigns;
